import type { Tier } from '@app-iptv/shared'

// Database de modelos conhecidos — ver §6.2.2 do PLAN.md
// Updates periódicos via release do app baseados em telemetria
export const KNOWN_MODELS: Record<string, Tier> = {
  // Fire TV (Amazon model codes)
  AFTKA: 'low', // Fire Stick Lite
  AFTKMST12: 'mid', // Fire Stick 4K Max
  AFTGAZL: 'high', // Fire TV Cube 3rd gen
  AFTSS: 'mid', // Fire TV Stick 4K (1st gen)
  AFTSSS: 'mid', // Fire TV Stick 4K (2nd gen)
  AFTMM: 'low', // Fire Stick (2nd gen)

  // Mi Box / Xiaomi (typically by UA)
  'mibox-3': 'low',
  'mibox-4': 'mid',
  'mibox-s': 'mid',

  // Nvidia Shield
  'shield-tv': 'high',
  'shield-pro': 'ultra',

  // Chromecast
  'chromecast-google-tv': 'mid',
  'chromecast-google-tv-4k': 'high',
}

/** Mapeia uma CHAVE de modelo já normalizada (resolvida em
 *  `platform.ts::detectPlatformInfo` — inclui Fire TV via `AFT*`, Nvidia Shield
 *  e Mi Box via UA) pro tier conhecido. Lookup puro por chave: a inteligência
 *  de UA vive na detecção de plataforma, não aqui. Retorna null pra modelo
 *  desconhecido → o pipeline cai no bench/RAM + teto de plataforma. */
export function lookupKnownModel(model: string | null): Tier | null {
  if (model && KNOWN_MODELS[model]) return KNOWN_MODELS[model]
  return null
}
